import { render, staticRenderFns } from "./ContractChangeMainBody.vue?vue&type=template&id=0c4165e0&scoped=true"
import script from "./ContractChangeMainBody.vue?vue&type=script&lang=js"
export * from "./ContractChangeMainBody.vue?vue&type=script&lang=js"
import style0 from "./ContractChangeMainBody.vue?vue&type=style&index=0&id=0c4165e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4165e0",
  null
  
)

export default component.exports